
import { useFunnelContext } from "shared/Funnel/FunnelContextProvider";
import { useCatalogPageContext } from "shared/catalog/CatalogPageContext/useCatalogPageContext";
import { trackProductListViewed, useTrack } from "utils/analytics/analytics.utils";

import { CatalogGrid } from "../CatalogGrid";

import { CatalogProductCardAvailable } from "./CatalogProductCardAvailable";

export const AvailableCatalog = (props: {
  layoutHasFilters?: boolean;
}) => {
  const { filteredAvailableEntries, selectedTagState: [selectedTag] } = useCatalogPageContext();
  const { isSwap } = useFunnelContext();

  // Tracker 
  useTrack(() => {
    if (!isSwap) {      
      trackProductListViewed({ list_id: selectedTag || "smartphones" });
    }
  });

  return (
    <>
      {(filteredAvailableEntries?.length || 0) > 0 && (
        <CatalogGrid layoutHasFilters={props.layoutHasFilters}>
          {filteredAvailableEntries?.map((product) => (
            <CatalogProductCardAvailable
              key={product.slug}
              brand={product.brand}
              slug={product.slug}
              modelName={product.modelName}
              isNew={product.isNew}
              isPreOrder={product.isPreOrder}
              isOutOfStock={product.isOutOfStock}
              image={product.picture}
              colorCodes={product.availableColors}
              upfrontPrice={product.minimumUpfrontPrice}
              subscriptionPrice={product.minimumSubscriptionPrice}
              originalUpfrontPrice={product.originalUpfrontPrice}
              originalSubscriptionPrice={product.originalSubscriptionPrice}
              tagSlugs={product.tagSlugs}
            />
          ))}
        </CatalogGrid>
      )}
    </>
  );
};
